import { eventBus } from '@/event-bus'

const state = {
  STAT_ITEM_MAX_LENGTH: 3,
  STAT_YEAR_INFO_WINDOW_MAX_LENGTH: 2,
  statItems: [],
  mapOptions: []
}

const getters = {
  statItemMaxCount () {
    return state.STAT_ITEM_MAX_LENGTH
  },
  statItemYearInfoWindowMaxCount: state => {
    return state.STAT_YEAR_INFO_WINDOW_MAX_LENGTH
  },
  statItemCount: state => {
    return state.statItems.length
  },
  selectedStatItems: state => {
    return state.statItems
  },
  findStatItem: state => (mapItmNo) => {
    return state.statItems.find(item => item.info.mapItmNo === mapItmNo)
  },
  findStatMenu: state => (mapSysNo) => {
    return state.statItems.find(item => item.mapSysNo === mapSysNo)
  },
  selectedYearList: state => {
    let yearList = []
    for (const statItem of state.statItems) {
      yearList = yearList.concat(statItem.years)
    }
    return yearList.filter((item, index) => yearList.indexOf(item) === index)
  },
  getStatMapTypes: state => {
    return state.statMapTypes
  },
  getMapOptions: state => {
    return state.mapOptions
  }
}

const mutations = {
  addStatItem (state, addStatItem) {
    state.statItems.push(addStatItem)
    for (const statItem of state.statItems) {
      if (statItem.years) {
        if (statItem.years.length > 0) {
          eventBus.$emit('sendEventMap')
          eventBus.$emit('sendDataBoard')
          break
        }
      }
    }
  },
  removeStatItem (state, itmIdx) {
    state.statItems.splice(itmIdx, 1)
    eventBus.$emit('sendEventMap')
    eventBus.$emit('sendDataBoard')
  },
  removeAllStatItem (stat) {
    state.statItems.splice(0)
    eventBus.$emit('sendEventMap')
    eventBus.$emit('sendDataBoard')
  },
  setStatItemYearList (state, { mapSysNo, yearList }) {
    for (const statItem of state.statItems) {
      if (statItem.mapSysNo === mapSysNo) {
        statItem.years = yearList
      }
    }
    eventBus.$emit('sendEventMap')
    eventBus.$emit('sendDataBoard')
  },
  setMapOptions (state, mapOptions) {
    state.mapOptions = mapOptions
    eventBus.$emit('sendMapOptions', mapOptions)
  }
}

const actions = {
  addStatItem ({ commit }, { mapSysNo, mapSysNm, srcCd, srcNo, info, years }) {
    years.sort((a, b) => b - a)

    const newStatItem = {
      info: info,
      mapSysNo: mapSysNo,
      mapSysNm: mapSysNm,
      srcCd: srcCd,
      srcNo: srcNo,
      years: years
    }
    commit('addStatItem', newStatItem)
  },
  removeStatItem ({ state, commit }, { info }) {
    const itemIdx = state.statItems.findIndex(item => item.info.mapItmNo === info.mapItmNo)
    commit('removeStatItem', itemIdx)
  },
  removeAllStatItem ({ state, commit }) {
    commit('removeAllStatItem')
  },
  setStatItemYearList ({ getters, commit }, { mapSysNo, yearList }) {
    const statMenu = getters.findStatMenu(mapSysNo)
    if (statMenu) {
      yearList.sort((a, b) => b - a)
      commit('setStatItemYearList', { mapSysNo: mapSysNo, yearList: yearList })
    }
  },
  setMapOptions ({ commit }, mapOptions) {
    commit('setMapOptions', mapOptions)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
